export const COMMUNITY_BADGE = "EXLY REFERRERS COMMUNITY";
export const COMMUNITY_TITLE = "You don't have to figure out referrals alone";
export const COMMUNITY_DESCRIPTION =
  "Join referrers and creators on WhatsApp. Get referral tips, ready-to-share creatives, payout updates and early access to new offers, straight from the Exly team.";

export const WHATSAPP_CTA_LABEL = "Join WhatsApp community";
export const FOOTER_INFO_TEXT = "Free to join · 150+ Community members";

export const DEFAULT_WHATSAPP_COMMUNITY_URL =
  "https://chat.whatsapp.com/DpkPj60ZlLSKCbT6jWxi1L";

export const COMMUNITY_PERKS = [
  {
    id: "weekly-tips",
    title: "Weekly referral tips",
    description: "What's working for top referrers right now.",
  },
  {
    id: "shareable-creatives",
    title: "Shareable creatives",
    description: "Posts and stories ready to send with your link.",
  },
  {
    id: "payout-updates",
    title: "Payout updates",
    description: "Know when commissions clear and land.",
  },
  {
    id: "early-offer-access",
    title: "Early offer access",
    description: "New discounts to share before anyone else.",
  },
];
